import classNames from 'classnames';

import { Dropdown } from '../../../bootstrap';
import { KebabToggle } from '../KebabToggle/KebabToggle';

export const KebabCell = ({
  dropdownItems,
  className,
}: {
  dropdownItems: {
    label: string;
    onClick: (...args: any) => any;
    style?: 'danger';
    disabled?: boolean;
  }[];
  className?: string;
}) => {
  return (
    <Dropdown align="end" className={classNames('d-flex p-1 justify-content-end', className)}>
      <Dropdown.Toggle as={KebabToggle} variant="success" id="dropdown-basic" />
      <Dropdown.Menu>
        {dropdownItems.map((item) => (
          <Dropdown.Item
            key={item.label}
            onClick={item.onClick}
            disabled={item.disabled}
            className={classNames({
              'u-color-red1 hover:u-color-red1 active:u-color-white': item.style === 'danger',
            })}
          >
            {item.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};
